import { triggerAuthFailure } from './authFailure';
import { apiOrigin } from '../utils/env';

export async function authFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const headers: Record<string, string> = {};

  if (init?.headers instanceof Headers) {
    init.headers.forEach((value, key) => {
      headers[key] = value;
    });
  } else if (Array.isArray(init?.headers)) {
    init.headers.forEach(([key, value]) => {
      headers[key] = value;
    });
  } else if (init?.headers) {
    Object.assign(headers, init.headers as Record<string, string>);
  }

  const token = localStorage.getItem('token');
  const hasAuthorization = Object.keys(headers).some((key) => key.toLowerCase() === 'authorization');

  if (token && !hasAuthorization) {
    headers.Authorization = `Bearer ${token}`;
  }

  const nextInit: RequestInit = { ...init };
  if (Object.keys(headers).length > 0) {
    nextInit.headers = headers;
  }

  const resolvedInput =
    typeof input === 'string' &&
    apiOrigin &&
    input.startsWith('/') &&
    !input.startsWith('http://') &&
    !input.startsWith('https://')
      ? `${apiOrigin}${input}`
      : input;

  const response = await fetch(resolvedInput, {
    ...nextInit,
  });

  if (response.status === 401) {
    triggerAuthFailure('session-expired');
  }

  return response;
}
